import React from 'react';
import { Switch } from 'react-router-dom';
import EmptyLayout from './layouts/EmptyLayout';
import AppRoute from "./AppRoute";
import MenuPage from './pages/MenuPage';
import NotFoundPage from './pages/NotFoundPage';
export const routes = <Switch>
    <AppRoute layout={EmptyLayout} exact path="/menu/:companyname" component={MenuPage} />
    <AppRoute layout={EmptyLayout} path="*" component={NotFoundPage} />
</Switch>